import * as React from "react";
import { cn } from "../../lib/utils.jsx";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={cn(
          "flex h-9 w-full rounded-md border border-white/15 bg-white/5 px-3 py-2 text-sm text-white",
          "placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500",
          className
        )}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export default Input;
